<template>
  <div class="works-filter__inner">
    <div class="works-filter__span">{{ $t("message.ShowFirst") }}:</div>
    <nav class="works-filter__nav">
      <ul>
        <li v-for="option in values">
          <a class="pointer" :class="sort.value==option.value?'active':''" v-on:click="sort=option">{{ option.labelShort }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>


<script>
  import SortTypeMix from "../../../../../components/list/filter/SortTypeMix";

  export default {
    name      : 'sort-type-sub',
    mixins: [SortTypeMix],

    methods: {
      get_value() {
        let val_str='';
        if (typeof this.value === 'object') val_str=this.value.value;

        return val_str;
      },

      set_val(new_val){
        //console.log(new_val);
        //this.$emit('input', new_val);
        //this.onChange ? this.onChange(new_val) : null;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/sub/flat_light/components/list/filter/SortTypeSub.vue